import { Contract } from '../types';
import { EMPLOYEE_CONTRACT_TYPES_ALIASES, BUSINESS_REGISTRATION_COUNTRY_REQUIRED_FORMS } from 'domain/shared/employee';

export const isBusinessRegistrationCountryVisible = ({
  contractType,
  contractingPartyForm,
}: Pick<Contract, 'contractType' | 'contractingPartyForm'>) =>
  contractType === EMPLOYEE_CONTRACT_TYPES_ALIASES.B2B ||
  (contractType === EMPLOYEE_CONTRACT_TYPES_ALIASES.CFS &&
    BUSINESS_REGISTRATION_COUNTRY_REQUIRED_FORMS.includes(String(contractingPartyForm || '')));
